<template>
  <Header />
  <div style="background-color: #f7f7f7; padding-bottom: 10px;">

    <div class="news-content">
      <div class="nav-link">当前位置： <a href="/">首页</a> > 关于我们</div>

      <div class="main-content">


        <div style=" letter-spacing: 1px; line-height: 32px;">
          北京四维安信软件有限公司是一家通过国家“双软认证”的高新技术软件服务企业，致力于构建智慧政务，构筑共享数字信息化成果的版权保护建设与发展。四维安信于2003年至今持续服务于测绘行业电子政务高效办公，为行业电子政务工作提供稳定可靠产品服务及解决方案，为行业企事业单位提供客服中心服务支持，提供电子数据版权保护产品服务、解决方案。
          <br />
          我们坚持以客户为中心。拙诚厚重，服务测绘地信行业；明理躬行，为客户创造长期价值。
        </div>

      </div>
    </div>
    <div class="friend-link">
      <ul>
        <li v-for="item in friendlyLinks">
          <a :href="item.linkUrl">{{ item.linkName }}</a>
        </li>
      </ul>
    </div>
  </div>
  <Footer />
</template>
<script setup>

import Header from "../components/header.vue";
import Footer from "../components/footer.vue";

import { getCurrentInstance, ref } from 'vue';


const { proxy } = getCurrentInstance();
let queryParams = ref({})
let friendlyLinks = ref([])


</script>
<style lang="scss" scoped>
.news-content {
  max-width: 1164px;
  width: 100%;
  border: 1px solid #eaeaea;
  margin: 0 auto;
  margin-top: 10px;
  background-color: #fff;
  padding-bottom: 10rem;

  .nav-link {
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    border-bottom: 1px solid #f8f8f8;
  }

  .main-content {

    padding: 15px;
  }
}
</style>
